import Vue from 'vue'
import Router from 'vue-router'


//运输 业务/////////////////
const order_class = () => import("@/components/ys_business/order_class"); //订单类型
const order_zh = () => import("@/components/ys_business/order_zh"); //订单-综合
// const order_fh = () => import("@/components/ys_business/order_fh"); //订单-发货
const order_hs = () => import("@/components/ys_business/order_hs"); //订单-护送
const order_ph = () => import("@/components/ys_business/order_ph"); //订单-配货
const order_sh = () => import("@/components/ys_business/order_sh"); //订单-上户

const trans = () => import("@/components/ys_business/trans"); //调度单
const transapply = () => import("@/components/ys_business/trans_apply"); //运输费用申请
const applysj = () => import("@/components/ys_business/apply_sj"); //司机费用申请
const applyjw = () => import("@/components/ys_business/apply_jw"); //就位费用申请
const applykl = () => import("@/components/ys_business/apply_kl"); //堪路费用申请

const transback = () => import("@/components/ys_business/trans_back");	//回单
const bumpinfo = () => import("@/components/ys_business/bump");	//冲撞仪
const bumptrans = () => import("@/components/ys_business/bump_trans");	//冲撞仪路程记录


Vue.use(Router)

//运输业务//////////////////////////
export default [

	{
		name: "order_class",
		path: "/order_class",
		component: order_class,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "订单分类"
		}
	},
	{
		name: "order_zh",
		path: "/order_zh",
		component: order_zh,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "订单综合"
		}
	},
	// {
	// 	name: "order_fh",
	// 	path: "/order_fh",
	// 	component: order_fh,
	// 	meta: {
	// 		requiresAuth: true,
	// 		keepAlive: true, // 不需要被缓存
	// 		title: "订单发货"
	// 	}
	// },
	{
		name: "order_hs",
		path: "/order_hs",
		component: order_hs,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "订单护送"
		}
	},
	{
		name: "order_ph",
		path: "/order_ph",
		component: order_ph,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "订单配货"
		}
	},
	{
		name: "order_sh",
		path: "/order_sh",
		component: order_sh,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "订单上户"
		}
	},
	{
		name: "trans",
		path: "/trans",
		component: trans,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "调度单"
		}
	},
	{
		name: "transapply",
		path: "/transapply",
		component: transapply,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "运输费用申请"
		}
	},
	{
		name: "applysj",
		path: "/applysj",
		component: applysj,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "司机报销申请"
		}
	},
	{
		name: "applyjw",
		path: "/applyjw",
		component: applyjw,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "就位费用申请"
		}
	},
	{
		name: "applykl",
		path: "/applykl",
		component: applykl,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "堪路费用申请"
		}
	},
	{
		name: "transback",
		path: "/transback",
		component: transback,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "回单"
		}
	},
	{
		name: "bumpinfo",
		path: "/bumpinfo",
		component: bumpinfo,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "冲撞仪"
		}
	},
	{
		name: "bumptrans",
		path: "/bumptrans",
		component: bumptrans,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "冲撞仪路程记录"
		}
	}


]
